import { render } from "./BTextarea.vue?vue&type=template&id=533a0580"
import script from "./BTextarea.vue?vue&type=script&lang=js"
export * from "./BTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__